import packageJson from '../package.json';
import joi from 'joi';

// +++ EXAMPLE_DATA +++

export const FWD_LIST_VKMM = { "prod": "690637d2c1fbfb36d0449759", "pre": "6760490e8be9161550c78a86", "dev": "6760490e8be9161550c78a86", "local": "6760490e8be9161550c78a86" };


// +++ SETTINGS +++

export var APPMODE = "prod" //CHANGE YOUR MODE: prod,dev,local,pre

const URL_MAINAPI_LOCAL = "http://localhost:7783/api"
const URL_MAINAPI_DEV = "https://dev-api.helferzeit.de/api"
const URL_MAINAPI_PRE = "https://dev-api.helferzeit.de/api"
const URL_MAINAPI_PROD = "https://api.helferzeit.de/api"

export var URL_MAINAPI = (APPMODE == "prod") ? URL_MAINAPI_PROD : (APPMODE == "dev") ? URL_MAINAPI_DEV : (APPMODE == "pre") ? URL_MAINAPI_PRE : URL_MAINAPI_LOCAL

export const API_TOKEN = "HZ2025bkjfgjJKBbj4324kfj392bk3B62JKvj65kB9J32J3b"

export var APPVERSION = packageJson.version;
export var APPNAME = packageJson.name;


// +++ CORE FUNCTIONS +++

export function lP(url) {
    window.location.href = url
}
export function oP(url) {
    window.open(url)
}
export function sT(element) {
    console.log("pressed");
    // document.querySelector(element).scrollIntoView()
    // document.getElementById("sec_next--home--services").scrollIntoView()
    window.scroll({
        behavior: 'smooth',
        left: 0,
        // top: document.querySelector(element).offsetTop - 40
        top: document.querySelector(element).offsetTop - 120
        // top: document.getElementById("sec_next--home--services").offsetTop - 120
    })
}


export function capFirstChar(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

export const boxvar1 = {
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.7, y: 50, transition: { duration: 0.5 } },
}
export const boxvar2 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5 } },
}

export const boxvar2_1 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.3 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.3 } },
}
export const boxvar2_2 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.6 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.6 } },
}
export const boxvar2_3 = {
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, delay: 0.9 } },
    hidden: { opacity: 0, x: 50, transition: { duration: 0.5, delay: 0.9 } },
}
export const boxvar3 = {
    visible: { opacity: 1, scale: 1, x: 0, transition: { duration: 0.5 } },
    hidden: { opacity: 0, scale: 0.8, x: 0, transition: { duration: 0.5 } },
}
export const boxvar4 = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.7 } },
    hidden: { opacity: 0, scale: 1, transition: { duration: 0.7 } },
}

export function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export function getBrowser(UAvar) {
    var sUsrAg = UAvar
    var sBrowser = ""

    if (sUsrAg.indexOf("Firefox") > -1) {
        sBrowser = "Mozilla Firefox"
        // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
        sBrowser = "Samsung Internet"
        // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
        sBrowser = "Opera"
        // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (sUsrAg.indexOf("Trident") > -1) {
        sBrowser = "Microsoft Internet Explorer"
        // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (sUsrAg.indexOf("Edge") > -1) {
        sBrowser = "Microsoft Edge"
        // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (sUsrAg.indexOf("Chrome") > -1) {
        sBrowser = "Google Chrome"
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (sUsrAg.indexOf("Safari") > -1) {
        sBrowser = "Apple Safari"
        // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
        sBrowser = "unknown"
    }
    return { 'browser': sBrowser, 'agent': sUsrAg }
}

export function formatDateWithTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Monate sind 0-basiert
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes} Uhr`;
}

/** Events nach dateStart absteigend (neueste zuerst), bei Gleichstand nach Name; ohne dateStart ans Ende. */
export function sortEventsByDateStartDesc(events) {
    return [...events].sort((a, b) => {
        const ta = a.dateStart ? new Date(a.dateStart).getTime() : Number.NEGATIVE_INFINITY
        const tb = b.dateStart ? new Date(b.dateStart).getTime() : Number.NEGATIVE_INFINITY
        if (ta !== tb) return tb - ta
        return String(a.name || '').localeCompare(String(b.name || ''), 'de', { sensitivity: 'base' })
    })
}

/** Wochentag aus EventSchedule-Datum (DD.MM.YYYY). Bei Fehler/ungültig: leerer String. */
export function getWeekdayFromScheduleDay(day) {
    try {
        if (day == null || day === '') return '';
        const dayStr = String(day).trim();
        const parts = dayStr.split('.');
        if (parts.length !== 3) return '';
        const dd = parseInt(parts[0], 10);
        const mm = parseInt(parts[1], 10);
        const yyyy = parseInt(parts[2], 10);
        if (!Number.isFinite(dd) || !Number.isFinite(mm) || !Number.isFinite(yyyy)) return '';
        if (parts[0].length < 1 || parts[1].length < 1 || parts[2].length !== 4) return '';

        const date = new Date(yyyy, mm - 1, dd);
        if (
            date.getFullYear() !== yyyy ||
            date.getMonth() !== mm - 1 ||
            date.getDate() !== dd
        ) {
            return '';
        }

        const weekdays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
        return weekdays[date.getDay()] || '';
    } catch (e) {
        return '';
    }
}

/** Anzeige: "Montag, 15.08.2026" bzw. nur das Datum, wenn kein Wochentag berechenbar. */
export function formatScheduleDayWithWeekday(day) {
    try {
        if (day == null || day === '') return '';
        const dayStr = String(day).trim();
        const weekday = getWeekdayFromScheduleDay(dayStr);
        if (!weekday) return dayStr;
        return `${weekday}, ${dayStr}`;
    } catch (e) {
        return day == null ? '' : String(day);
    }
}

export function flattenObject(obj, parentKey = '') {
    let result = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = parentKey ? `${parentKey}.${key}` : key; // Verschachtelte Keys mit Punkt verbinden
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                Object.assign(result, flattenObject(obj[key], newKey)); // Rekursiv flach machen
            } else {
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}

/** Lädt ein PDF von der MainAPI und startet den Browser-Download. Wirft bei HTTP- oder Netzwerkfehlern. */
export async function downloadPdf(path, filename, authtoken) {
    const response = await fetch(URL_MAINAPI + path, {
        method: "GET",
        headers: {
            'APITOKEN': API_TOKEN,
            'authtoken': authtoken
        },
    })
    if (!response.ok) throw new Error('PDF konnte nicht geladen werden')
    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
}

export function convertToCSV(data) {

    // Flache das Array
    const flatData = data.map(item => flattenObject(item));

    // Hole die Header (Spaltennamen)
    const headers = Object.keys(flatData[0]);

    const csvRows = [];

    // Füge Header zur CSV hinzu
    csvRows.push(headers.join(','));

    // Iteriere durch jedes flache Objekt und hole die Werte
    for (const row of flatData) {
        const values = headers.map(header => {
            let value = row[header];

            // Wenn der Wert ein String mit Komma ist, setze ihn in Anführungszeichen
            if (typeof value === 'string' && value.includes(',')) {
                value = `"${value}"`;
            }

            // Wenn der Wert ein verschachteltes Objekt war, wurde es schon als JSON-String eingefügt, daher einfach übernehmen
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }

            return value;
        });

        // Füge die Zeile zur CSV hinzu
        csvRows.push(values.join(','));
    }

    // Gib die CSV-Daten als String zurück
    return csvRows.join('\n');
}

export function downloadCSV(csvContent, filename) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) { // Nur wenn download unterstützt wird
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    }
}

/** Nutzerfreundliche Meldung für Fehler aus startRegistration()/startAuthentication(); null = vom Nutzer abgebrochen. */
export function describePasskeyError(err) {
    if (err && (err.name === 'NotAllowedError' || err.name === 'AbortError')) return null
    if (err && err.name === 'InvalidStateError') return 'Auf diesem Gerät bzw. in diesem Passwortmanager ist bereits ein Passkey für dein Konto gespeichert.'
    if (err && err.name === 'SecurityError') return 'Passkeys sind auf dieser Domain nicht verfügbar.'
    return (err && err.message) ? err.message : 'Unbekannter Fehler'
}

export function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}


// +++ VALIDATION (shared schemas: Registrierung, Profil, Passwort) +++

const RE_EMAIL = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
const RE_TEL = /^(?=[0-9+]{3,16})((0)|(\+[0-9]{1,3})) {0,1}([0-9 ]{4,13})$/;
const RE_STREETCHARS = /^[A-Za-z0-9.,\-\/\sÀ-ÿ]*$/;
const RE_QUALI = /^[A-Za-z\-.,\/À-ÿ\s]*$/;

export function validateContactFields(data) {
    return joi.object({
        "email": joi.string().trim().min(6).max(50).pattern(RE_EMAIL).required(),
        "tel": joi.string().trim().min(6).max(20).pattern(RE_TEL).required(),
        "mobile": joi.string().trim().min(6).max(20).optional().pattern(RE_TEL).empty(''),
    }).validate(data)
}

export function validateAddressFields(data) {
    const normalized = {
        ...data,
        nr: data && data.nr != null ? String(data.nr) : data && data.nr,
        zipcode: data && data.zipcode != null ? String(data.zipcode) : data && data.zipcode,
    }
    return joi.object({
        "nr": joi.string().trim().min(1).max(10).pattern(/^[A-Za-z0-9.,\-\/\s]*$/).required(),
        "street": joi.string().trim().min(3).max(30).pattern(RE_STREETCHARS).required(),
        "addon": joi.string().trim().max(30).optional().pattern(RE_STREETCHARS).empty(''),
        "zipcode": joi.string().trim().min(4).max(5).pattern(/^[0-9]*$/).required(),
        "city": joi.string().trim().min(3).max(30).pattern(/^[A-Za-z0-9.\-\sÀ-ÿ]*$/).required(),
    }).validate(normalized)
}

export function validateRegistrationExtra(data) {
    const now = Date.now();
    const cutoffDateMax = new Date(now - (1000 * 60 * 60 * 24 * 365 * 5));
    const cutoffDateMin = new Date(now - (1000 * 60 * 60 * 24 * 365 * 120));
    return joi.object({
        "newsletter_agreed": joi.number().valid(0, 1).required(),
        "photos_agreed": joi.number().valid(0, 1).required(),
        "agb_agreed": joi.number().valid(1).required(),
        "qualifications": joi.string().trim().min(0).max(50).optional().pattern(RE_QUALI).empty(''),
        "preferred_channel": joi.number().valid(1, 2).required(),
        "birthday": joi.date().min(cutoffDateMin).max(cutoffDateMax).required()
    }).validate(data)
}

export function validateProfileBase(data) {
    const now = Date.now();
    const cutoffDateMax = new Date(now - (1000 * 60 * 60 * 24 * 365 * 5));
    const cutoffDateMin = new Date(now - (1000 * 60 * 60 * 24 * 365 * 120));
    return joi.object({
        "firstname": joi.string().trim().min(2).max(30).required(),
        "lastname": joi.string().trim().min(2).max(30).required(),
        "tel": joi.string().trim().min(6).max(20).pattern(RE_TEL).required(),
        "mobile": joi.string().trim().min(6).max(20).optional().pattern(RE_TEL).empty(''),
        "qualifications": joi.string().trim().min(0).max(50).optional().pattern(RE_QUALI).empty(''),
        "preferred_channel": joi.number().valid(1, 2).required(),
        "birthday": joi.date().min(cutoffDateMin).max(cutoffDateMax).required(),
    }).validate(data)
}

export function validateEmail(email) {
    return joi.object({
        "email": joi.string().trim().min(6).max(50).pattern(RE_EMAIL).required(),
    }).validate({ email: email })
}

export function validateOrganizationUpdate(data) {
    return joi.object({
        "name": joi.string().trim().min(2).max(80).pattern(/^[A-Za-z0-9.\-/\sÀ-ÿ&()]*$/).required(),
        "description": joi.string().trim().min(0).max(1000).optional().allow(''),
        "email": joi.string().trim().min(6).max(80).pattern(RE_EMAIL).required(),
        "tel": joi.string().trim().min(6).max(30).pattern(RE_TEL).required(),
        "url": joi.alternatives().try(
            joi.string().trim().allow(''),
            joi.string().trim().min(5).max(400).uri()
        ).optional(),
        "imprint_url": joi.string().trim().min(5).max(400).uri().required(),
    }).validate(data)
}

export function validateObjectId(id) {
    return joi.object({
        "userid": joi.string().trim().length(24).hex().required(),
    }).validate({ userid: id })
}

export function validatePassword(password) {
    return joi.object({
        "password": joi.string().min(6).max(30)
            .pattern(/[A-ZÄÖÜ]/, 'Großbuchstabe')
            .pattern(/[0-9]/, 'Zahl')
            .pattern(/[^A-Za-z0-9ÄÖÜäöüß\s]/, 'Sonderzeichen')
            .required(),
    }).validate({ password: password })
}